import styled from 'styled-components'

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  max-height: calc(85vh - 80px);
  overflow-y: auto;
`

export const ModalTitle = styled.h2`
  margin: 0;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.5;
  color: #282832;
`

export const OrDivider = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  width: 100%;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 1.65;
  color: #282832;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background-color: #d4d4d6;
  }
`

export const SocialButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;

  & > * {
    flex: 1;
    min-width: 0;
  }
`

export const SocialButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  min-height: 40px;
  flex-shrink: 0;
  background-color: #ffffff;
  border: 1px solid #3e3e47;
  border-radius: 4px;
  padding: 0 24px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.65;
  color: #3e3e47;
  text-decoration: none;
  cursor: pointer;
  box-sizing: border-box;

  &:hover {
    background-color: #f5f5f7;
  }
`

export const CustomCheckbox = styled.label`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #3e3e47;
  cursor: pointer;
  width: 100%;

  & > input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
    width: 0;
    height: 0;
  }

  & > span.label {
    flex: 1;
    min-width: 0;
  }
`

export const CheckboxBox = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 2px;
  border: 1px solid #3e3e47;
  background-color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 1px;
  box-sizing: border-box;

  & > svg {
    visibility: hidden;
  }

  input[type='checkbox']:checked + & {
    background-color: #3e3e47;

    & > svg {
      visibility: visible;
    }
  }
`

export const BenefitsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
`

export const BenefitItem = styled.li`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
  font-size: 14px;
  line-height: 165%;
  color: #282832;
  flex-shrink: 0;
`

export const Divider = styled.hr`
  width: 100%;
  height: 1px;
  border: none;
  background-color: #d4d4d6;
  margin: 0;
`

export const DividerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  width: 100%;
  font-size: 14px;
  color: #5e5e65;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background-color: #d4d4d6;
  }
`

export const FieldRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;

  & > * {
    flex: 1;
    min-width: 0;
  }
`

export const FieldsStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const PrimaryButton = styled.button`
  width: 100%;
  height: 40px;
  min-height: 40px;
  flex-shrink: 0;
  background-color: #282832;
  color: #ffffff;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.65;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:disabled {
    background-color: #c9c9cc;
    color: #7e7e84;
    cursor: default;
  }

  &:hover:not(:disabled) {
    background-color: #3e3e47;
  }
`

export const SecondaryLink = styled.button`
  display: block;
  width: 100%;
  background: none;
  border: none;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.65;
  color: #282832;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: none;
  }
`

export const ForgotPasswordLink = styled.a`
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.65;
  color: #282832;
  text-decoration: underline;
  cursor: pointer;
  align-self: flex-start;

  &:hover {
    text-decoration: none;
  }
`

export const LegalText = styled.p`
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 1.65;
  letter-spacing: 0.4px;
  color: #282832;
  text-align: center;
  margin: 0;

  a {
    color: #05629b;
    font-weight: 500;
    text-decoration: underline;
  }
`

export const CheckboxRow = styled.label`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: flex-start;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 1.65;
  color: #282832;
  cursor: pointer;

  input {
    margin-top: 3px;
    flex-shrink: 0;
  }
`

export const PasswordWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const PasswordHint = styled.p`
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 1.65;
  color: #5e5e65;
  margin: 0;
`

export const ErrorText = styled.p`
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 1.65;
  color: #cc3333;
  margin: 0;
`

export const ErrorToast = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  box-sizing: border-box;
  background: #ffffff;
  border: 2px solid #cc3333;
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.1);
`

export const ErrorToastIcon = styled.span`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const ErrorToastBody = styled.div`
  flex: 1;
  min-width: 0;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 1.65;
  color: #282832;

  a {
    color: #05629b;
    text-decoration: underline;
  }

  a:hover {
    text-decoration: none;
  }
`

export const VerificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const VerificationHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
`

export const VerificationHeadline = styled.h2`
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.5;
  color: #282832;
  margin: 0 16px 0 0;
  white-space: pre-wrap;
  flex: 1;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  color: #282832;
`

export const VerificationIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 8px;
`

export const VerificationBody = styled.p`
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 1.65;
  color: #282832;
  text-align: center;
  margin: 0;
`

export const ResendRow = styled.p`
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 1.65;
  color: #282832;
  text-align: center;
  margin: 0;
`

export const ResendLink = styled.button`
  background: none;
  border: none;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  line-height: 1.65;
  color: #05629b;
  text-decoration: underline;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: none;
  }
`

export const SectionHeading = styled.p`
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.65;
  color: #282832;
  margin: 0;
`

export const HintText = styled.p`
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 1.65;
  color: #5e5e65;
  font-style: italic;
  text-align: center;
  margin: 0;
`
